import MultiplicationGameAnswer from "./MultiplicationGameAnswer";
import {isNullOrUndefined} from "../../../../services/Validator";

export default function MultiplicationGameAnsweringBlock({currentQuestion, userAnswer}) {
    // Used in MultiplicationGameContent to display both question
    // and answering form

    // BUILD
    if (isNullOrUndefined(currentQuestion))
        return null
    const tokens = tokenizeMathExpression(currentQuestion);
    return (
        <div className="w-full flex justify-between items-center text-[40px] font-medium">
            {tokens.map((token, index) => (
                <span key={index}
                      className={renderTokenStyle(token)}>
                    {token}
                </span>
            ))}
            <MultiplicationGameAnswer
                answer={userAnswer} />
        </div>
    );

    // METHODS
    // ---- UI : Tokenize question for style treatment
    function tokenizeMathExpression(expr) {
        return expr.trim().split(/\s+/);
    }

    // ---- UI : Render span style
    function renderTokenStyle(token) {
        return ["+", "-", "×", "x", "÷"].includes(token)
            ? "text-timerBlue font-normal text-[40px]"
            : token === "="
                ? "text-greyLight9"
                : "text-white"
    }
}